import HeroBusiness from "@/components/common/HeroBusiness";
import PageTitleBox from "@/components/common/PageTitleBox";
import Container from "@/components/layout/Container";
import { useState } from "react";
import { Link } from "react-router-dom";

type TabType = "aimer" | "ammer" | "phone-mail";

const tabContents = {
  aimer: {
    title: "대량 메일(AIMER)",
    intro:
      "최단 시간내에 최대 물량의 메일을 전송할 수 있는 대량 메일 발송 솔루션으로서, 메일 발송 엔진과 Web Console로 이루어져 있으며 캠페인/개인 등 독립 메시지의 개별 전송이 가능한 1:1마케팅 툴입니다.",
    goals:
      "비용 효율적인 대량 마케팅 수단 확보 - 비용 대비 고객 접근성이 뛰어난 대량 마케팅 채널을 개발\n정교한 CRM 툴 구현 - 타깃 수신율, 개봉율, 정보 반응도를 파악하여 고객 관계 관리(CRM)를 심층적으로 수행할 수 있는 본격적인 도구를 개발",
    features: [
      {
        title: "명세서 발송 자동화",
        description: "웹 콘솔을 통해 제작된 캠페인별 공통 내용을 손쉽게 발송",
      },
      {
        title: "성과 확인 및 데이터 축적",
        description:
          "수신/개봉율을 확인하고, RGAW 수정을 통해 수신 확인 및 오퍼 클릭 데이터를 DB에 축적, 분석하여 고객 1:1 마케팅 소스를 확보",
      },
      {
        title: "타깃 세분화",
        description: "축적된 반응 정보를 토대로 고객 관심 분야를 분석하여 타깃 세그먼트를 구체화",
      },
      {
        title: "CRM 강화 및 매출 연계",
        description: "1:1 메일링을 통해 개별 고객의 관심을 지속적으로 유도하여 매출 증대로 연계",
      },
    ],
  },
  ammer: {
    title: "웹 메일(AMMER)",
    intro:
      "캠페인성 메일처럼 발송 시작과 끝이 존재하는 것이 아닌, 상시/개별적으로 요청되는 발송을 처리하기 위한 Mailer로서, 기존 Sendmail 시스템과 달리 하나의 메일 발송 전담 서버를 운영하여 통계 분석 및 실시간 모니터링, 메일 발송 등이 중앙 시스템에서 손쉽게 운용될 수 있는 장점이 있습니다.",
    goals: [
      "메일 발송의 긴급/실시간성 확보",
      "일반 Sendmail 시스템과 다른, 모니터링/DB 호환 등의 가능한 Tool 확보",
    ],
    features: [
      "다양한 방식으로 메일 본문 취득 가능 (URL, Static HTML, TXT file, Template file, DB query)",
      "DB를 직접 접근 할 수 없는 곳에서도 URL을 통하여 원격으로 메일 전송이 가능하며, 메일 전송에 대한 결과 (성공/실패/수신확인 등)를 Remote Notification Call의 인터페이스를 이용하여 알림이 가능",
      "보안 메일 인터페이스를 가지고 있어 보안 메일 전송이 가능",
      "중앙 집중적 관리 및 모니터링 및 통계 분석이 가능",
      "배치 발송 기능 지원",
      "메일 전송 우선 순위 설정 가능",
      "성공, 실패 및 실패 사유에 대한 내역 기록, 수신 확인 가능",
    ],
  },
  "phone-mail": {
    title: "Phone Number Mail",
    intro:
      "발신자가 핸드폰 번호를 수신 메일 주소로 지정하여 메일을 전송할수 있도록 하는 서비스입니다. E-mail 수신 알림 SMS, MMS, 전송, WAP 메일 또는 ARS(TTS) 접속 등의 확장형 부가 서비스와 접목하여 사용 가능합니다.",
    systemFeatures: [
      "폰번호 계정 정리(SMS)",
      "멀티미디어 메시지(MMS)",
      "메일 개봉 서비스(ARS)",
      "메일 서비스 정리(WAP)",
    ],
    usageList: [
      "메일 도착 알람 SMS 발송",
      "E-mail을 MMS로 변환하여 발송",
      "TTS를 이용한 메일 확인",
      "WAP Mail 확인",
    ],
  },
};

const BusinessMail = () => {
  const [activeTab, setActiveTab] = useState<TabType>("aimer");

  const renderAimerContent = () => {
    const content = tabContents.aimer;
    return (
      <div>
        <div className="mb-10">
          <h2 className="text-[2.4rem] font-bold mb-4">{content.title}</h2>
          <p className="text-[1.6rem] text-gray-6 leading-[1.8]">{content.intro}</p>
        </div>

        <div className="mb-10">
          <h3 className="text-[1.8rem] font-semibold mb-4">서비스 목표</h3>
          <p className="text-[1.5rem] text-gray-6 leading-[1.8] whitespace-pre-line bg-[#f8f9ff] rounded-xl p-6">
            {content.goals}
          </p>
        </div>

        <div>
          <h3 className="text-[1.8rem] font-semibold mb-4">서비스 특징</h3>
          <ul className="space-y-4">
            {content.features.map((feature, idx) => (
              <li
                key={idx}
                className="flex items-start gap-4 text-[1.5rem] p-4 bg-white rounded-lg border border-gray-2"
              >
                <strong className="text-navy whitespace-nowrap">{feature.title} :</strong>
                <span className="text-gray-6">{feature.description}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  const renderAmmerContent = () => {
    const content = tabContents.ammer;
    return (
      <div>
        <div className="mb-10">
          <h2 className="text-[2.4rem] font-bold mb-4">{content.title}</h2>
          <p className="text-[1.6rem] text-gray-6 leading-[1.8]">{content.intro}</p>
        </div>

        <div className="mb-10">
          <h3 className="text-[1.8rem] font-semibold mb-4">서비스 목표</h3>
          <ul className="space-y-3">
            {content.goals.map((goal, idx) => (
              <li key={idx} className="flex items-start gap-3 text-[1.5rem] text-gray-6">
                <span className="material-icons-round text-navy text-[1.8rem]">flag</span>
                {goal}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-[1.8rem] font-semibold mb-4">서비스 기능</h3>
          <ul className="space-y-3">
            {content.features.map((feature, idx) => (
              <li key={idx} className="flex items-start gap-3 text-[1.5rem] text-gray-6">
                <span className="material-icons-round text-navy text-[1.8rem]">check</span>
                {feature}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  const renderPhoneMailContent = () => {
    const content = tabContents["phone-mail"];
    return (
      <div>
        <div className="mb-10">
          <h2 className="text-[2.4rem] font-bold mb-4">{content.title}</h2>
          <p className="text-[1.6rem] text-gray-6 leading-[1.8]">{content.intro}</p>
        </div>

        <div>
          <h3 className="text-[1.8rem] font-semibold mb-6">서비스 기능</h3>
          <p className="text-[1.4rem] text-gray-5 mb-4">• 수신 거부 ARS 서비스</p>
          <div className="bg-[#f8f9ff] rounded-2xl p-8">
            <div className="flex flex-wrap justify-center items-center gap-8">
              {/* Source */}
              <div className="text-center">
                <div className="w-20 h-20 mx-auto mb-3 p-4 bg-white rounded-xl shadow-sm">
                  <img
                    src="/img/business/icon_telecom.svg"
                    alt="외부 Web Mail"
                    className="w-full h-full object-contain"
                  />
                </div>
                <p className="text-[1.4rem] font-medium">
                  외부 Web Mail /
                  <br />
                  법인 POP3 / CRM 등
                </p>
              </div>

              <div className="flex flex-col items-center">
                <span className="text-[1.3rem] text-gray-5 mb-2">
                  휴대폰번호@arreo.com
                  <br />
                  메일로 이메일 전송
                </span>
                <span className="material-icons-round text-navy text-[2rem]">east</span>
              </div>

              {/* System */}
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <p className="text-[1.5rem] font-semibold text-navy mb-4">폰넘버 메일 시스템</p>
                <ul className="space-y-2">
                  {content.systemFeatures.map((feature, idx) => (
                    <li key={idx} className="text-[1.4rem] text-gray-5">
                      • {feature}
                    </li>
                  ))}
                </ul>
              </div>

              <span className="material-icons-round text-navy text-[2rem] hidden md:block">
                east
              </span>

              {/* Usage */}
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <ul className="space-y-2">
                  {content.usageList.map((usage, idx) => (
                    <li key={idx} className="text-[1.4rem] text-gray-6">
                      • {usage}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container>
      <HeroBusiness title="비즈니스를 완성하는" />

      <section id="main-content">
        <PageTitleBox
          badge="메일"
          title={
            <>
              최단 시간, 최대 물량,
              <br />
              <strong className="text-navy">메일 마케팅의 정석</strong>
            </>
          }
          subtitle={
            <>
              대량메일, 웹메일, 폰넘버메일까지
              <br />
              다양한 메일 솔루션을 만나보세요.
            </>
          }
        />

        {/* Tabs */}
        <nav className="mb-12">
          <ul className="flex flex-wrap justify-center gap-3" role="tablist">
            {(["aimer", "ammer", "phone-mail"] as TabType[]).map(tab => (
              <li key={tab}>
                <button
                  role="tab"
                  aria-selected={activeTab === tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-8 py-4 rounded-full text-[1.6rem] font-medium transition-colors ${
                    activeTab === tab
                      ? "bg-navy text-white"
                      : "bg-gray-1 text-gray-6 hover:bg-gray-2"
                  }`}
                >
                  {tab === "aimer"
                    ? "대량 메일(AIMER)"
                    : tab === "ammer"
                      ? "웹 메일(AMMER)"
                      : "Phone Number Mail"}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* Tab Content */}
        <div className="bg-white rounded-3xl p-8 lg:p-12 shadow-sm border border-gray-1">
          {activeTab === "aimer" && renderAimerContent()}
          {activeTab === "ammer" && renderAmmerContent()}
          {activeTab === "phone-mail" && renderPhoneMailContent()}
        </div>

        {/* CTA */}
        <section className="text-center py-16 mt-12">
          <h3 className="text-[2.8rem] font-bold mb-4">
            비즈니스에 최적화된
            <br />
            메일 솔루션을 경험해보세요
          </h3>
          <Link
            to="/service/submit"
            className="inline-flex items-center gap-2 mt-6 px-8 py-4 bg-navy text-white rounded-full text-[1.6rem] font-medium hover:bg-navy/90 transition-colors"
          >
            서비스 신청하기
            <span className="material-icons-round">arrow_forward</span>
          </Link>
        </section>
      </section>
    </Container>
  );
};

export default BusinessMail;
